import onResizeDebounced from '../util/onResizeDebounced';
import Swiper, { Navigation, Pagination } from 'swiper';

export default class ContentCarousel {
  constructor() {
    this.classNames = {
      block: 'b-af-content-carousel',
      slider: 'b-af-content-carousel__slider',
      body: 'b-af-content-carousel__body',
      pagination: 'b-af-content-carousel__pagination',
      buttonPrev: 'b-af-content-carousel__button--prev',
      buttonNext: 'b-af-content-carousel__button--next',
      enableSlider: 'enable-slider',
      blockStaticBoxes: 'b-af-content-carousel--static-boxes',
    };

    this.blocks = Array.from(document.querySelectorAll(`.${this.classNames.block}`));

    if (this.blocks.length === 0) return;

    this.init();
  }

  init() {
    this.blocks.forEach((block) => {
      this.initBlock({ block });
      this.handleSliderWidth({ block });
    });
  }

  initBlock({ block }) {
    const slider = block.querySelector(`.${this.classNames.slider}`);
    if (slider.classList.contains(this.classNames.enableSlider)) {
      console.log('test');
      this.initSwiper({ block });
      return;
    }

    this.handleNoSlider({ block });
  }

  handleNoSlider({ block }) {
    block.classList.add(this.classNames.blockStaticBoxes);
  }

  initSwiper({ block }) {
    const slider = block.querySelector(`.${this.classNames.slider}`);
    const pagination = block.querySelector(`.${this.classNames.pagination}`);
    const buttonPrev = block.querySelector(`.${this.classNames.buttonPrev}`);
    const buttonNext = block.querySelector(`.${this.classNames.buttonNext}`);

    Swiper.use([Navigation, Pagination]);

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesOffsetAfter: 20,
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        prevEl: buttonPrev,
        nextEl: buttonNext,
      },
      breakpoints: {
        992: {
          slidesPerView: 'auto',
          spaceBetween: 30,
          slidesOffsetAfter: 40,
        },
      },
    });
  }

  handleSliderWidth({ block }) {
    const body = block.querySelector(`.${this.classNames.body}`);

    this.getAndSetSliderWidth({ block, body });

    onResizeDebounced(() => {
      this.getAndSetSliderWidth({ block, body });
    }, 200);
  }

  getAndSetSliderWidth({ block, body }) {
    const { left, width } = body.getBoundingClientRect();

    block.style.setProperty('--afu-slider-right-offset', `${window.innerWidth - left - width}px`);
  }
}




// WEBPACK FOOTER //
// ./scripts/blocks/contentCarousel.js